/** Scheduled admin workflows use the selected organization, never an implicit account scope. */
export function workflowDraftApiPath(organizationId?: string): string {
    return organizationId
        ? `/organizations/${encodeURIComponent(organizationId)}/workflow-builder/drafts`
        : "/workflow-builder/drafts";
}
